import { constants } from "@newsela/angelou";

const greyLight = constants.colors.ui.neutral[25];

export const contentPanelWrapperLoadingCss = {
  alignItems: "center",
  backgroundColor: greyLight,
  display: "flex",
  justifyContent: "center",
  minHeight: "500px",
  minWidth: "100%",
};

export const contentPanelRowWrapperCss = {
  padding: "0",
  margin: "0",
  display: "flex",
  flexDirection: "column",
  "& > :first-child": {
    minHeight: "500px",
  },
};
